// extracted by css-extract-rspack-plugin
export default {"cls1":"Upsell-cls1_FP_","cls2":"Upsell-cls2_c64 Upsell-cls1_FP_"};